import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { slackDeauthorize, slackRedirect } from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import { setIntegrationAvailable, setIntegrationData } from '../../redux/slices/integrationsSlice';
import { selectSlackAvailable } from '../../redux/selectors/integrationsSelectors';
import { selectAuthIsTeamOwner, selectAuthToken } from '../../redux/selectors/authSelectors';

const SlackIntegration = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectAuthToken);
  const isTeamOwner = useSelector(selectAuthIsTeamOwner);
  const slackAvailable = useSelector(selectSlackAvailable);

  const [slackUrl, setSlackUrl] = useState(null);

  useEffect(() => {
    setSlackUrl(
      `https://slack.com/oauth/v2/authorize?scope=groups%3Aread%2Cchannels%3Aread%2Cchat%3Awrite%2Epublic%2Cchat%3Awrite&redirect_uri=${slackRedirect()}&client_id=325462627205.3326589578003&state=${token}`
    );
  }, [token]);

  const handleDeauthClick = (e) => {
    e.preventDefault();
    slackDeauthorize(token).then((status) => {
      if (status) {
        toast.success('Success: Slack account has been deauthorized', {
          position: 'top-right',
          autoClose: 4000,
        });
        dispatch(
          setIntegrationData({
            id: 'slack',
            data: { channels: [] },
          })
        );
        dispatch(
          setIntegrationAvailable({ id: 'slack', available: false })
        );
      } else {
        toast.error('Error: There was a problem deauthorizing Slack.', {
          position: 'top-right',
          autoClose: 4000,
        });
      }
    });
  };

  let slackButton = '';
  if (isTeamOwner && slackUrl) {
    slackButton = slackAvailable ? (
      <>
        <Card.Header as='h5' className='cstm-card-title'>
          Slack Configuration
        </Card.Header>{' '}
        <Card.Body>
          <Card.Title>Slack Channel Configuration</Card.Title>{' '}
          <Card.Text>
            Update which channels you want to allow notifications to.
          </Card.Text>
          <a className='add_to_slack_btn' href='#/config/slack' role='button'>
            Update Channel Selection
          </a>
          <Card.Text style={{ marginTop: '20px' }}>
            Need to unplug Slack or reauthorize to a different account?
          </Card.Text>
          <a
            href='#deauthorize-slack'
            className='add_to_slack_btn gray_btn'
            onClick={(e) => handleDeauthClick(e)}
            role='button'
          >
            Deauthorize Slack
          </a>
        </Card.Body>
      </>
    ) : (
      <>
        <Card.Header as='h5'>Slack Configuration</Card.Header>
        <Card.Body>
          <Card.Title>
            Click the below button to authorize Security Bulldog to push
            document shares and other messages to any of Slack Channels you
            choose. You will need be able to log into your Slack workspace and
            be authorized to add apps.
          </Card.Title>
          <Card.Text>
            Once Slack is authorized you will redirect back to Security Bulldog
            to select the Slack Channels you would like messages delivered to.
          </Card.Text>
          <a className='add_to_slack_btn' href={slackUrl}>
            Authorize Slack
          </a>
        </Card.Body>
      </>
    );
  }
  return (
    <Container>
      <Row>
        <Col lg={12}>
          <div className='mt-4 add_to_slack_wrap'>
            <Card>{slackButton}</Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SlackIntegration;
